import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react-lite';

import { TCredentials } from '../../core';

const { Password } = Input;

type LoginFormProps = {
  onSubmit: (credentials: TCredentials) => void;
};

export const LoginForm = observer(({ onSubmit }: LoginFormProps) => {
  return (
    <Form
      name="login"
      layout="vertical"
      requiredMark={false}
      style={{ width: '100%' }}
      onFinish={onSubmit}
    >
      <Form.Item
        name="login"
        label="Логин"
        rules={[{ required: true, message: 'Пожалуйста введите логин' }]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="login"
          autoComplete="username"
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="Пароль"
        rules={[{ required: true, message: 'Пожалуйста введите пароль' }]}
      >
        <Password
          prefix={<LockOutlined />}
          type="password"
          placeholder="••••••••"
          autoComplete="current-password"
        />
      </Form.Item>

      <Button type="primary" htmlType="submit" block>
        Войти
      </Button>
    </Form>
  );
});
